import type { RootStateType } from "State/Store";
import { useSelector } from "react-redux";

export const useLoggedInUser = () =>
  useSelector((state: RootStateType) => state.auth.user);
